import { render, staticRenderFns } from "./BasicTextInput.vue?vue&type=template&id=c3db9042&scoped=true"
import script from "./BasicTextInput.vue?vue&type=script&lang=js"
export * from "./BasicTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db9042",
  null
  
)

export default component.exports